<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
            <path
                d="M19.8125 6.84375C14.2812 1.75 5.6875 1.75 0.156251 6.84375C-0.0624995 7.0625 -0.0624995 7.375 0.125001 7.5625L1.1875 8.625C1.40625 8.8125 1.71875 8.84375 1.90625 8.65625C6.46875 4.46875 13.5 4.46875 18.0625 8.65625C18.2812 8.84375 18.5625 8.8125 18.7812 8.625L19.8438 7.5625C20.0312 7.375 20.0312 7.0625 19.8125 6.84375ZM10 13C8.875 13 8 13.9062 8 15C8 16.125 8.875 17 10 17C11.0938 17 12 16.125 12 15C12 13.9062 11.0938 13 10 13ZM16.3125 10.4062C12.7188 7.21875 7.25 7.21875 3.65625 10.4062C3.4375 10.5938 3.4375 10.9375 3.625 11.125L4.71875 12.1875C4.90625 12.375 5.1875 12.375 5.40625 12.2188C8.03125 9.9375 11.9375 9.9375 14.5625 12.2188C14.7813 12.375 15.0625 12.375 15.25 12.1875L16.3438 11.125C16.5312 10.9375 16.5312 10.5938 16.3125 10.4062Z"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
